import { gql, useMutation } from '@apollo/client';
import {
  UpsertClientAndCreateTransactionInput,
  MercadoPagoCreatePurchaseResponse,
} from 'apollo/types';

const UPSERT_MERCADOPAGO_PURCHASE = gql`
  mutation upsertMercadoPagoTransaction(
    $clientArguments: UpsertClientArgs!
    $purchaseArguments: CreatePurchaseInputArgs!
    $billingSystemArguments: BillingSystemInputArgs!
  ) {
    createPurchase(
      input: {
        clientArguments: $clientArguments
        purchaseArguments: $purchaseArguments
        billingSystemArguments: $billingSystemArguments
      }
    ) {
      url
      token
    }
  }
`;
const upsertMercadoPagoTransactionMutation = () => {
  return useMutation<
    MercadoPagoCreatePurchaseResponse,
    UpsertClientAndCreateTransactionInput
  >(UPSERT_MERCADOPAGO_PURCHASE);
};

export default upsertMercadoPagoTransactionMutation;
